
































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Maintenance extends Vue {
  now: Date | null = null;
  get extraordinaryMaintenance(): boolean {
    this.now = new Date();
    if (!this.now) {
      return false;
    }
    // 臨時メンテナンス対応 redmine : https://nasa.future.co.jp/ode/redmine/issues/6028
    return (
      this.now >= new Date('2026-04-20T21:30:00+09:00') &&
      this.now <= new Date('2026-04-21T07:00:00+09:00')
    );
  }
}
